import React from "react";

export const PayoutLogo = ({
  width = "30",
  height = "30",
  fill = "none",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "5px" }}
  >
    <path
      d="M2.78809 13.4979L13.4789 2.80713M15.5263 9.21291L13.6934 11.0458M12.1291 12.5915L11.3135 13.4071"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M2.64558 13.4508C1.34039 12.1456 1.34039 10.0294 2.64558 8.72426L8.72444 2.6454C10.0296 1.34021 12.1458 1.34021 13.4509 2.6454L17.3544 6.54893C18.6597 7.85412 18.6597 9.97026 17.3544 11.2754L11.2756 17.3543C9.97044 18.6595 7.85431 18.6595 6.54911 17.3543L2.64558 13.4508Z"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.5"
    />
    <path
      d="M3.33331 18.3335H16.6666"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
